import React, { useState, useEffect, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./AdmRegistration.css";
import { useNavigate } from "react-router-dom";
import useFetchClasses from "../../hooks/useFetchClasses";
import useFetchSections from "../../hooks/useFetchSections";
import Select from "react-select";
import { Link } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import * as XLSX from "xlsx";
import ReactPaginate from "react-paginate";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const AdmAttendanceEntry = ({ formData, setFormData }) => {
  const navigate = useNavigate();
  const { classes } = useFetchClasses();
  const [selectedClass, setSelectedClass] = useState("");
  const { sections } = useFetchSections(selectedClass);
  const [studentData, setStudentData] = useState([]);
  const [fullStudentData, setFullStudentData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // State for current page
  const rowsPerPage = 10;
  // Calculate total pages
  const totalPages = Math.ceil(studentData.length / rowsPerPage);
  // Get the current rows for the table
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = studentData.slice(indexOfFirstRow, indexOfLastRow);
  const [filters, setFilters] = useState({
    searchText: "",
    studentName: "",
    classId: "",
    section: "",
    admissionNo: "",
    barcode: "",
    fatherName: "",
    motherName: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    gender: "",
  });
  const [isSearching, setIsSearching] = useState(false);
  // useEffect(() => {
  //   const fetchFullStudentData = async () => {
  //     try {
  //       const academicSessionId = localStorage.getItem('academicSessionId');
  //       if (!academicSessionId) {
  //         console.error('No academic session ID found in local storage');
  //         return;
  //       }
  //       const response = await fetch(`${ApiUrl.apiurl}  STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`);

  //       if (!response.ok) {
  //         throw new Error('Error fetching student data');
  //       }
  //       const data = await response.json();
  //       if (data.data) {
  //         setFullStudentData(data.data);
  //         setStudentData(data.data);
  //       } else {
  //         console.warn('No data found for the given academic session ID');
  //       }
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     }
  //   };
  //   fetchFullStudentData();
  // }, []);

  useEffect(() => {
    const fetchFullStudentData = async () => {
      try {
        const academicSessionId = localStorage.getItem("academicSessionId");
        if (!academicSessionId) {
          console.error("No academic session ID found in local storage");
          return;
        }

        // Corrected the URL by removing extra spaces
        const response = await fetch(
          `${ApiUrl.apiurl}STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}`
        );

        if (!response.ok) {
          throw new Error("Error fetching student data");
        }

        const data = await response.json();
        if (data.data) {
          setFullStudentData(data.data);
          setStudentData(data.data);
        } else {
          console.warn("No data found for the given academic session ID");
        }
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    fetchFullStudentData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleCancelCloseButton = () => {
    navigate("/admin/dashboard");
  };


  //Same date adding all dropdown for filteration
  const handleSearch = useCallback(async () => {
    setIsSearching(true);
    try {
      const academicSessionId = localStorage.getItem("academicSessionId");
      if (!academicSessionId) {
        console.error("No academic session ID found in local storage");
        setStudentData([]);
        setIsSearching(false);
        return;
      }

      const classId = Array.isArray(filters.classId)
        ? filters.classId[0]
        : filters.classId;
      const sectionId = Array.isArray(filters.section)
        ? filters.section[0]
        : filters.section;

      const params = new URLSearchParams();

      if (classId) params.append("classId", classId); // Maps to addmitted_class
      if (sectionId) params.append("sectionId", sectionId); // Maps to addmitted_section
      if (filters.studentName) params.append("first_name", filters.studentName);
      if (filters.admissionNo)
        params.append("admission_no", filters.admissionNo);
      if (filters.fatherName) params.append("father_name", filters.fatherName);
      if (filters.motherName) params.append("mother_name", filters.motherName);
      if (filters.status) params.append("student_status", filters.status);
      if (filters.gender) params.append("gender", filters.gender);
      if (filters.barcode) params.append("barcode", filters.barcode);
      const apiUrl = `${
        ApiUrl.apiurl
      }STUDENTREGISTRATIONAPI/GetAllSTUDENTList/${academicSessionId}?${params.toString()}`;

      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error("Error fetching student data");
      }

      const data = await response.json();
      if (!data.data || data.data.length === 0) {
        console.warn("No data found for this academic session and filters");
        setFullStudentData([]);
        setStudentData([]);
        return;
      }

      const allStudents = data.data;

      // Frontend filtering as a fallback
      const filteredStudents = allStudents.filter((student) => {
        const basic = student.studentBasicDetails || {};
        const address = (student.addressDetails && student.addressDetails[0]) || {};
        const fullName = `${basic.first_name || ""} ${
          basic.middle_name || ""
        } ${basic.last_name || ""}`
          .trim()
          .toLowerCase();
        const normalizeGender = (value) =>
          (value || "").toString().trim().toLowerCase();
        const searchNameParts = filters.studentName
          .toLowerCase()
          .split(" ")
          .filter(Boolean);
        const nameMatches = searchNameParts.every((part) =>
          fullName.includes(part)
        );
        const searchBlob = [
          basic.id,
          basic.admission_no,
          basic.school_admission_no,
          basic.first_name,
          basic.middle_name,
          basic.last_name,
          basic.classname,
          basic.sectionname,
          basic.father_name,
          basic.mother_name,
          basic.gender,
          basic.barcode,
          basic.student_status,
          address.present_address,
          address.present_district,
          address.present_state,
          address.present_country,
          address.permanent_address,
          address.permanent_district,
          address.permanent_state,
          address.permanent_country,
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();
        const searchTextMatches =
          !filters.searchText ||
          searchBlob.includes(filters.searchText.toLowerCase());

        return (
          searchTextMatches &&
          (!filters.studentName || nameMatches) &&
          (!filters.admissionNo ||
            (basic.admission_no &&
              basic.admission_no.toString().includes(filters.admissionNo)) ||
            (basic.school_admission_no &&
              basic.school_admission_no
                .toString()
                .includes(filters.admissionNo))) &&
          (!filters.barcode ||
            basic.barcode?.toString().includes(filters.barcode)) &&
          (!filters.fatherName ||
            basic.father_name
              ?.toLowerCase()
              .includes(filters.fatherName.toLowerCase())) &&
          (!filters.motherName ||
            basic.mother_name
              ?.toLowerCase()
              .includes(filters.motherName.toLowerCase())) &&
          (!filters.status ||
            basic.student_status?.toLowerCase() ===
              filters.status.toLowerCase()) && // ✅ fixed
          // (!filters.gender || basic.gender === filters.gender) &&
          (!filters.gender ||
            normalizeGender(basic.gender) === normalizeGender(filters.gender)) &&
          (!classId ||
            basic.addmitted_class?.toString() === classId.toString()) &&
          (!sectionId ||
            basic.addmitted_section?.toString() === sectionId.toString())
        );
      });

      setFullStudentData(allStudents);
      setStudentData(filteredStudents);
      setCurrentPage(1);
    } catch (error) {
      console.error("Search fetch error:", error);
      setStudentData([]);
    } finally {
      setIsSearching(false);
    }
  }, [filters]);

  useEffect(() => {
    handleSearch();
  }, [handleSearch]);

  // Export Excel data by Priyabrata on 04.14.2025
  const flattenStudentData = (data) => {
    return data.map((student, index) => {
      const basic = student.studentBasicDetails || {};
      const address =
        (student.addressDetails && student.addressDetails[0]) || {};
      const fee = (student.feeDetails && student.feeDetails[0]) || {};

      return {
        ID: basic.id,
        AdmissionNo: basic.admission_no,
        FirstName: basic.first_name,
        LastName: basic.last_name,
        Gender: basic.gender,
        DOB: basic.dob,
        Email: basic.email,
        FatherName: basic.father_name,
        MotherName: basic.mother_name,
        ContactNo: basic.father_contact_number,
        PresentAddress: address.present_address,
        City: address.present_city || address.present_district,
        PresentState: address.present_state,
        District: address.present_district,
        PermanentAddress: address.permanent_address,
        PermanentCity: address.permanent_city || address.permanent_district,
        PermanentState: address.permanent_state,
        PermanentDistrict: address.permanent_district,
        FeeGroup: fee.feegroup,
        FeeAppFrom: fee.feeappform,
      };
    });
  };

  const handleClear = () => {
    setFilters({
      searchText: "",
      studentName: "",
      classId: "",
      section: "",
      admissionNo: "",
      barcode: "",
      fatherName: "",
      motherName: "",
      gender: "",
      status: "",
    });
    setSelectedClass("");
    setStudentData(fullStudentData);
  };

  // Export to Excel function
  const exportToExcel = () => {
    if (fullStudentData && fullStudentData.length > 0) {
      const flattened = flattenStudentData(fullStudentData);
      const worksheet = XLSX.utils.json_to_sheet(flattened);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "StudentData");
      XLSX.writeFile(workbook, "Registration_Data.xlsx");
    } else {
      alert("No data available to export!");
    }
  };

  const exportToPdf = () => {
    if (!studentData || studentData.length === 0) {
      alert("No data available to export!");
      return;
    }

    const doc = new jsPDF("landscape");
    const title = "Student Search Report";
    const rows = studentData.map((student, index) => {
      const basic = student.studentBasicDetails || {};
      return [
        index + 1,
        `${basic.first_name || ""} ${basic.middle_name || ""} ${
          basic.last_name || ""
        }`.trim(),
        basic.admission_no || basic.school_admission_no || "",
        basic.classname || "",
        basic.sectionname || "",
        basic.father_name || "",
        basic.mother_name || "",
        basic.barcode || "",
      ];
    });

    doc.setFontSize(14);
    doc.text(title, 14, 14);
    doc.setFontSize(10);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 20);

    autoTable(doc, {
      startY: 26,
      head: [[
        "S.No.",
        "Name",
        "Admission No",
        "Class",
        "Section",
        "Father's Name",
        "Mother's Name",
        "Barcode",
      ]],
      body: rows,
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [33, 37, 41],
      },
      margin: { top: 26 },
    });

    doc.save("Registration_Data.pdf");
  };

  const handleClassChange = (e) => {
    const classId = e.target.value;
    setSelectedClass(classId);
    setFilters((prevFilters) => ({
      ...prevFilters,
      classId: classId,
    }));
  };
  // const handleSectionChange = (e) => {
  //   const sectionId = e.target.value;
  //   setFilters((prevFilters) => ({
  //     ...prevFilters,
  //     section: sectionId,
  //   }));
  // };
  const handleSectionChange = (e) => {
    const sectionId = e.target.value; // This is the section_id from the response
    setFilters((prevFilters) => ({
      ...prevFilters,
      section: sectionId,
    }));
  };

  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1); // react-paginate is 0-based, so add 1
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                STUDENT SEARCH
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={() => navigate("/admstudentregistration")}
                  >
                    New
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={handleSearch}
                    disabled={isSearching}
                  >
                    {isSearching ? "Searching..." : "Search"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    onClick={handleCancelCloseButton}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={exportToExcel}
                  >
                    Export To Excel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    onClick={exportToPdf}
                  >
                    Export to PDF
                  </button>
                </div>
              </div>
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-2">
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="studentName" className="form-label">
                          Student Name
                        </label>
                        <input
                          type="text"
                          id="studentName"
                          name="studentName"
                          className="form-control detail"
                          placeholder="Enter student name"
                          value={filters.studentName}
                          onChange={handleInputChange}
                        />
                      </div>
                      {/* <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="admitted-class" className="form-label">
                          Admitted Class<span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        {classLoading ? (
                          <p>Loading classes...</p>
                        ) : (
                          <select
                            className="detail"
                            value={selectedClass}
                            onChange={handleClassChange}
                          >
                            <option value="">Select Class</option>
                            {classes.map((item, index) => (
                              <option key={index} value={item.id}>
                                {item.classname}
                              </option>
                            ))}{" "}
                          </select>
                        )}{" "}
                      </div> */}
                      <div className="col-12 col-md-3 mb-2">
                        <label htmlFor="admitted-class" className="form-label">
                          Class<span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          id="admitted-class"
                          className="detail"
                          classNamePrefix="admitted-class-select"
                          options={[
                            { value: "", label: "Select Class" },
                            ...classes.map((item) => ({
                              value: item.id,
                              label: item.classname,
                            })),
                          ]}
                          value={
                            selectedClass
                              ? {
                                  value: selectedClass,
                                  label:
                                    classes.find(
                                      (cls) => cls.id === selectedClass
                                    )?.classname || "Select Class",
                                }
                              : { value: "", label: "Select Class" }
                          }
                          onChange={(selectedOption) =>
                            handleClassChange({
                              target: { value: selectedOption.value },
                            })
                          }
                        />
                      </div>
                      {/* <div className="col-12 col-md-3 mb-2">
                        <label
                          htmlFor="admitted-section"
                          className="form-label"
                        >
                          Admitted Section
                        </label>
                        <Select
                          className="detail"
                          classNamePrefix="admitted-section-select"
                          options={sections.map((item) => ({
                            value: item.id,
                            label: item.sectionname,
                          }))}
                          value={
                            filters.section
                              ? {
                                value: filters.section,
                                label:
                                  sections.find(
                                    (sec) => sec.id === filters.section
                                  )?.sectionname || "",
                              }
                              : null
                          }
                          onChange={(selectedOption) =>
                            handleSectionChange({
                              target: {
                                value: selectedOption
                                  ? selectedOption.value
                                  : "",
                              },
                            })
                          }
                          placeholder="Select Section"
                        />
                      </div> */}
                      <div className="col-12 col-md-3 mb-2">
                        <label
                          htmlFor="admitted-section"
                          className="form-label"
                        >
                          Section
                        </label>
                        <Select
                          className="detail"
                          classNamePrefix="admitted-section-select"
                          options={[
                            { value: "", label: "Select Section" },
                            ...sections.map((item) => ({
                              value: item.section_id, // Use section_id from response
                              label: item.sectionname,
                            })),
                          ]}
                          value={
                            filters.section
                              ? {
                                  value: filters.section,
                                  label:
                                    sections.find(
                                      (sec) =>
                                        sec.section_id === filters.section
                                    )?.sectionname || "Select Section",
                                }
                              : { value: "", label: "Select Section" }
                          }
                          onChange={(selectedOption) =>
                            handleSectionChange({
                              target: {
                                value: selectedOption
                                  ? selectedOption.value
                                  : "",
                              },
                            })
                          }
                          placeholder="Select Section"
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="admissionNo" className="form-label">
                          Admission No.
                        </label>
                        <input
                          type="text"
                          id="admissionNo"
                          name="admissionNo"
                          className="form-control detail"
                          placeholder="Enter admission number"
                          value={filters.admissionNo}
                          onChange={handleInputChange}
                        />{" "}
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="barcode" className="form-label">
                          Barcode
                        </label>
                        <input
                          type="text"
                          id="barcode"
                          name="barcode"
                          className="form-control detail"
                          placeholder="Enter barcode"
                          value={filters.barcode}
                          onChange={handleInputChange}
                        />{" "}
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="fatherName" className="form-label">
                          Father's Name
                        </label>
                        <input
                          type="text"
                          id="fatherName"
                          name="fatherName"
                          className="form-control detail"
                          placeholder="Enter father's name"
                          value={filters.fatherName}
                          onChange={handleInputChange}
                        />{" "}
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="motherName" className="form-label">
                          Mother's Name
                        </label>
                        <input
                          type="text"
                          id="motherName"
                          name="motherName"
                          className="form-control detail"
                          placeholder="Enter mother's name"
                          value={filters.motherName}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="status" className="form-label">
                          Status
                        </label>
                        <Select
                          id="status"
                          className="detail"
                          classNamePrefix="status-select"
                          options={[
                            { value: "", label: "Select Status" },
                            { value: "ACTIVE", label: "ACTIVE" },
                            { value: "INACTIVE", label: "INACTIVE" },
                          ]}
                          value={[
                            { value: "", label: "Select Status" },
                            { value: "ACTIVE", label: "ACTIVE" },
                            { value: "INACTIVE", label: "INACTIVE" },
                          ].find((option) => option.value === filters.status)}
                          onChange={(selectedOption) =>
                            setFilters((prevFilters) => ({
                              ...prevFilters,
                              status: selectedOption
                                ? selectedOption.value
                                : "",
                            }))
                          }
                        />
                      </div>
                      

                      <div className="col-12 col-md-3 mb-4">
                        <label htmlFor="gender" className="form-label">
                          Gender
                        </label>
                        <Select
                          id="gender"
                          className="detail"
                          classNamePrefix="gender-select"
                          options={[
                            { value: "", label: "Select gender" },
                            { value: "Male", label: "Male" },
                            { value: "Female", label: "Female" },
                          ]}
                          value={[
                            { value: "", label: "Select gender" },
                            { value: "Male", label: "Male" },
                            { value: "Female", label: "Female" },
                          ].find((option) => option.value === filters.gender)}
                          onChange={(selectedOption) =>
                            setFilters((prevFilters) => ({
                              ...prevFilters,
                              gender: selectedOption
                                ? selectedOption.value
                                : "",
                            }))
                          }
                        />
                      </div>

                      <div className="col-12 mb-3 mt-1">
                        <input
                          type="text"
                          id="searchText"
                          name="searchText"
                          className="form-control detail"
                          placeholder="Search: name, admission no, class, section, address, state ..."
                          value={filters.searchText}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>{" "}
                  </div>{" "}
                </div>{" "}
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover table-sm">
                      <thead className="table-dark">
                        <tr>
                          <th scope="col">S.No.</th> <th scope="col">Name</th>{" "}
                          <th scope="col">Admission No</th>
                          <th scope="col">Class</th>{" "}
                          <th scope="col">Section</th>{" "}
                          <th scope="col">Gender</th>
                          <th scope="col">City</th>
                          <th scope="col">State</th>
                          <th scope="col">Father's Name</th>
                          <th scope="col">Mother's Name</th>{" "}
                          <th scope="col">Barcode</th>{" "}
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      {/* <tbody>
                        {currentRows.map((student, index) => {
                          const { studentBasicDetails } = student;
                          return (
                            <tr key={index}>
                              <td>{indexOfFirstRow + index + 1}</td>
                              <td>{`${studentBasicDetails.first_name} ${studentBasicDetails.middle_name} ${studentBasicDetails.last_name}`}</td>
                              <td>{studentBasicDetails.school_admission_no}</td>
                              <td>{studentBasicDetails.classname}</td>
                              <td>{studentBasicDetails.sectionname}</td>
                              <td>{studentBasicDetails.father_name}</td>{" "}
                              <td>{studentBasicDetails.mother_name}</td>{" "}
                              <td>{studentBasicDetails.barcode}</td>
                              <td>
                                <Link
                                  to={`/admstudentregistration/${studentBasicDetails.id}`}
                                  className="btn btn-sm btn-primary"
                                >
                                  Edit{" "}
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>{" "} */}
                      <tbody>
                        {currentRows.length > 0 ? (
                          currentRows.map((student, index) => {
                            const { studentBasicDetails } = student;
                            const address = (student.addressDetails && student.addressDetails[0]) || {};
                            return (
                              <tr key={index}>
                                <td>{indexOfFirstRow + index + 1}</td>
                                <td>{`${studentBasicDetails.first_name} ${
                                  studentBasicDetails.middle_name || ""
                                } ${studentBasicDetails.last_name}`}</td>
                                <td>{studentBasicDetails.admission_no}</td>
                                <td>{studentBasicDetails.classname}</td>
                                <td>{studentBasicDetails.sectionname}</td>
                                <td>{studentBasicDetails.gender || "-"}</td>
                                <td>{address.present_city || address.present_district || "-"}</td>
                                <td>{address.present_state || "-"}</td>
                                <td>{studentBasicDetails.father_name}</td>
                                <td>{studentBasicDetails.mother_name}</td>
                                <td>{studentBasicDetails.barcode}</td>
                                <td>
                                  <Link
                                    to={`/admstudentregistration/${studentBasicDetails.id}`}
                                    className="btn btn-sm btn-primary"
                                  >
                                    Edit
                                  </Link>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="12" style={{ textAlign: "center" }}>
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {/* Pagination controls */}
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      pageCount={totalPages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={currentPage - 1} // keep sync with state
                    />
                  </div>{" "}
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};
export default AdmAttendanceEntry;
